import { msalInstance } from "vue-msal-browser";

let activeMsAccount = null;

const initialState = activeMsAccount
  ? {
      status: { loggedIn: true },
      message: "",
      msAccount: activeMsAccount,
    }
  : { status: { loggedIn: false }, message: "", msAccount: null };

export const msAccount = {
  namespaced: true,
  state: initialState,

  actions: {
    initMsAccount({ commit }) {
      let activeMsAccount = msalInstance.getActiveAccount();
      if (activeMsAccount !== null) {
        commit("msLoginSuccess", activeMsAccount);
      } else {
        let accountJson = localStorage.getItem("msLoginAccount");
        console.log("initMsAccount");
        // console.log(accountJson);
        if (accountJson) {
          let account = JSON.parse(accountJson);
          console.log(account.homeAccountId);
          let accounts = msalInstance.getAllAccounts();
          console.log(accounts);
          accounts.forEach(function(item) {
            if (item.homeAccountId == account.homeAccountId) {
              msalInstance.setActiveAccount(account);
              commit("msLoginSuccess", account);
            }
          });
        }
      }
    },
    loginMsAccount({ commit }, account) {
      commit("msLoginSuccess", account);
      console.log("msLoginMsAccount");
    },
    logoutMsAccount({ commit }) {
      commit("msLogout");
    },
  },

  mutations: {
    msLoginSuccess(state, account) {
      state.status.loggedIn = true;
      state.msAccount = account;
      state.message = "msLoginSuccess";
      localStorage.setItem("msLoginAccount", JSON.stringify(account.account));
      console.log("msLoginSuccess");
      console.log(account);
    },
    msLoginFailure(state) {
      state.status.loggedIn = false;
      state.msAccount = null;
      localStorage.removeItem("msLoginAccount");
    },
    msLogout(state) {
      state.status.loggedIn = false;
      state.msAccount = null;
      console.log("msLogout");
      state.message = "msLogout";
      localStorage.removeItem("msLoginAccount");
    },
  },
  getters: {
    msAccount: state => {
      return state.account;
    },
  },
};
